import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const IfcIcon = ({ color = '#fbb03b', text = 'IFC' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default IfcIcon;
